import { DrawerProps } from 'components/commercetools-ui/atoms/drawer';
import useOnClickOutside from 'helpers/hooks/useOnClickOutside';
import React, { useRef } from 'react';

const CartDrawer = ({ className = '', isOpen, onClose, children }: React.PropsWithChildren<any>) => {
  const ref = useRef<HTMLDivElement>(null);

  useOnClickOutside(ref, () => {
    if (isOpen) onClose?.();
  });

  return (
    <div
      style={{ display: isOpen ? 'block' : 'none' }}
      className={`fixed right-[6%] top-72 z-[999] min-h-[100px] w-[90%] max-w-[380px] rounded-md bg-white shadow-lg transition-transform duration-500 ease-in-out ${
        isOpen ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'
      }`}
      ref={ref}
    >
      <div className="flex h-full flex-col items-stretch" onMouseLeave={() => onClose()}>
        {children}
      </div>
    </div>
  );
};

export default CartDrawer;
